export default __webpack_public_path__ + "static/media/@kessiarosaoficial.06436398.jpg";